import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b33f2e42"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dingtalk-login"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "login_qrcode_container"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login_qrcode_text"
}, "请使用钉钉扫描二维码登录", -1));
const _hoisted_4 = [_hoisted_2, _hoisted_3];
import { ElMessage } from 'element-plus';
import { OAuthController } from '@/api/system/index';

import { ref, onMounted, onUnmounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  ...{
    name: 'DingTalkLogin'
  },
  __name: 'login',
  props: {
    bindSocial: {
      type: Boolean,
      default: false
    },
    dialog: {}
  },
  emits: ['success', 'error'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const ddInstance = ref();
    const emit = __emit;
    const r = (e, t) => {
      const r = e.match(new RegExp('[?&]' + t + '=([^&]+)'));
      return r ? r[1] : null;
    };
    const DTFrameLogin = (e, t, n, o) => {
      const i = t;
      const u = e.id && document.getElementById(e.id) || null;
      const c = document.createElement('iframe');
      if (t.client_id && t.redirect_uri && t.response_type && t.scope) {
        if (u) {
          u.innerHTML = '';
          u.appendChild(c);
          if (c && c.contentWindow && c.contentWindow.postMessage && window.addEventListener) {
            c.src = 'https://' + (i.isPre ? 'pre-login' : 'login') + '.dingtalk.com/oauth2/auth?iframe=true&redirect_uri=' + i.redirect_uri + '&response_type=' + i.response_type + '&client_id=' + i.client_id + '&scope=' + i.scope + (i.prompt ? '&prompt=' + i.prompt : '') + (i.state ? '&state=' + i.state : '') + (i.org_type ? '&org_type=' + i.org_type : '') + (i.corpId ? '&corpId=' + i.corpId : '') + (i.exclusiveLogin ? '&exclusiveLogin=' + i.exclusiveLogin : '') + (i.exclusiveCorpId ? '&exclusiveCorpId=' + i.exclusiveCorpId : '');
            c.width = '' + (e.width || 300);
            c.height = '' + (e.height || 300);
            c.frameBorder = '0';
            c.scrolling = 'no';
            const handleMessage = event => {
              const t = event.data;
              const i = event.origin;
              if (/login\.dingtalk\.com/.test(i) && t) {
                console.log('钉钉回调', event);
                if (t.success && t.redirectUrl) {
                  const u = t.redirectUrl;
                  const c = r(u, 'authCode') || '';
                  const d = r(u, 'state') || '';
                  const s = r(u, 'error') || '';
                  console.log(u, c, d, s);
                  c ? n && n({
                    redirectUrl: u,
                    authCode: c,
                    state: d
                  }) : o && o(s);
                } else {
                  o && o(t.errorMsg);
                }
              }
            };
            console.log('绑定钉钉消息监听');
            window.addEventListener('message', handleMessage, false);
            return {
              destroy: () => {
                window.removeEventListener('message', handleMessage, false);
              }
            };
          } else {
            o && o('Browser not support');
          }
        } else {
          o && o('Element not found');
        }
      } else {
        o && o('Missing parameters');
      }
    };
    onMounted(() => {
      const redirectUri = encodeURIComponent(process.env.VUE_APP_DINGTALK_REDIRECT_URI);
      ddInstance.value = DTFrameLogin({
        id: 'login_qrcode_container',
        width: 350,
        height: 280
      }, {
        redirect_uri: redirectUri,
        client_id: process.env.VUE_APP_DINGTALK_CLIENT_ID,
        scope: 'openid',
        response_type: 'code',
        state: '123456',
        prompt: 'consent'
      }, loginResult => {
        const {
          redirectUrl,
          authCode,
          state
        } = loginResult;
        // redirectUrl中有code和authCode，值好像是一样的，若不同，须重新组装链接，将authCode赋值给code参数，使后台可以使用统一的参数code来处理鉴权逻辑
        if (props.bindSocial) {
          OAuthController.bind({
            source: 'dingtalk',
            code: authCode,
            state
          }).then(res => {
            console.log('钉钉绑定成功', res);
            if (props.dialog) {
              ElMessage.success('绑定成功');
              props.dialog.submit(res);
            }
            emit('success', res);
          }).catch(e => {
            emit('error', e);
          });
        } else {
          OAuthController.login({
            source: 'dingtalk',
            code: authCode,
            state
          }).then(res => {
            console.log('钉钉登录成功', res);
            if (props.dialog) {
              props.dialog.submit(res);
            }
            emit('success', res);
          }).catch(e => {
            console.warn('钉钉登录失败');
            emit('error', e);
          });
        }
      }, errorMsg => {
        // 这里一般需要展示登录失败的具体原因,可以使用toast等轻提示
        ElMessage.error(errorMsg);
      });
    });
    onUnmounted(() => {
      if (ddInstance.value) ddInstance.value.destroy();
      ddInstance.value = null;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4);
    };
  }
});